<div class="active-call-container">
  <div class="call-info text-white" [ngClass]="{
      'bg-gray': call.isTransfering() && call.transferInType === CallTransferType.ASSISTED,
      'bg-primary': !call.isTransfering() || call.transferInType === CallTransferType.NOT_ASSISTED
    }">
    <div fxLayoutAlign="center center" class="client-info-container" [ngClass]="{'onhold': call.isOnhold()}">
      <div class="client-info mt-1 mb-1">
        <a *ngIf="clientName" (click)="call.isCrmContact() && openContactProfile()" class="client-name">
          {{ clientName }}</a>
        <div class="client-phone-number">
          <strong class="info-call-row" (click)="call.isCrmContact() && openContactProfile()">
            <ng-container *ngIf="call.isInbound(); else OutboundBlock">
              <mat-icon class="text-white icon-inbound">south</mat-icon>
            </ng-container>
            <ng-template #OutboundBlock>
              <mat-icon class="text-white icon-inbound">north</mat-icon>
            </ng-template>
            <span class="client-number" [ngClass]="{'client-no-name': !clientName}">
              {{ call.remoteNumberInLocalFormat() }}</span>
          </strong>
        </div>
        <div *ngIf="call.isAnswered() && call.answerTime">
          <mat-icon class="text-white icon-time">{{ !call.isOnhold() ? 'access_time' : 'pause_presentation' }}
          </mat-icon>
          <timer-since [since]="(!call.isOnhold() ? call.answerTime : call.onholdTime)" class="call-timmer">
          </timer-since>
        </div>

      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="wrapper-info-call" [ngClass]="{'onhold': call.isOnhold()}">
      <div class="info-call-row" *ngIf="queueName && !isCampaign">
        <!-- <ng-container *ngIf="call.isInbound(); else OutboundBlock">
          <mat-icon class="text-white icon-inbound">south</mat-icon>
          <span>{{ 'public.inbound'|translate }}</span>
        </ng-container>
        <ng-template #OutboundBlock>
          <mat-icon class="text-white icon-inbound">north</mat-icon>
          <span>{{ 'public.outbound'|translate }}</span>
        </ng-template> -->

        <mat-icon class="icon-phone">notes</mat-icon>
        <span>{{ queueName }}</span>
      </div>
      <div class="info-call-row">
        <mat-icon class="icon-phone">phone</mat-icon>
        <span>{{ call.localNumberInLocalFormat() }}</span>
      </div>
      <!-- <div class="info-call-row" *ngIf="thirdCallData && thirdCallData.start_dt">&nbsp;</div> -->
    </div>
    <mat-divider></mat-divider>

    <ng-container *ngIf="thirdCallData">
      <div class="wrapper-info-call third-call-data" [ngClass]="{'onhold': call.isOnhold()}">
        <div class="info-call-row">
          <ng-container *ngTemplateOutlet="OutboundBlock"></ng-container>
        </div>
        <div class="info-call-row">
          <mat-icon class="icon-phone">phone</mat-icon>
          <span *ngIf="thirdCallData">{{ thirdCallData.remote_number|displayPhoneNumber }}</span>
        </div>
        <ng-container *ngIf="thirdCallData && thirdCallData.start_dt">
          <div class="info-call-row">
            <mat-icon class="text-white icon-time">access_time</mat-icon>
            <timer-since [since]="thirdCallData.start_dt" class="call-timmer"></timer-since>
          </div>
          <div class="info-call-row">
            <button mat-icon-button type="button" class="bt-hangup" (click)="removeParticipant()">
              <mat-icon class="valign">call_end</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>
      <mat-divider></mat-divider>
    </ng-container>

    <ng-container *ngIf="hasFeatureGroup && uimodeCallCenter() && groupName">
      <div class="call-info-remote">
        <div class="info-call-supp mt-5">
          <div fxFlex="30">{{ 'call_active.group'|translate }}</div>
          <div class="group-name px-1">{{ groupName }}</div>
        </div>
        <!-- <div *ngIf="call.transferInType === 0" class="info-call-supp">
        <div fxFlex="30">{{ 'call_active.transfer_blind_to' | translate }}</div>
        <div class="transfer-user px-1">{{ call.transferInUser?.name }}</div>
      </div>
      <div *ngIf="call.transferInType === 1" class="info-call-supp">
        <div fxFlex="30">{{ 'call_active.transfer_assisted_to' | translate }}</div>
        <div class="transfer-user px-1">{{ call.transferInUser?.name }}</div>
      </div>
      <div *ngIf="call.transferReason" class="info-call-supp">
        <div fxFlex="30">{{ 'call_active.transfer_reason' | translate }}</div>
        <div class="transfer-reason px-1">{{ call.transferReason }}</div>
      </div>
        <div *ngIf="call.isTransfering()" class="info-call-supp">
          <div fxFlex="30">{{ 'call_active.transfering_to' | translate }}</div>
          <div class="transfer-destination px-1">{{ call.transferDestination }}</div>
        </div> -->
      </div>
      <mat-divider class="mb-0"></mat-divider>
    </ng-container>
  </div>


  <div class="call-message" [ngClass]="{
      'bg-gray': call.isTransfering() && call.transferInType === CallTransferType.ASSISTED, 
      'bg-primary-light': !call.isTransfering() || call.transferInType === CallTransferType.NOT_ASSISTED
    }">
    <div class="active-call-info" *ngIf="callData">
      <active-call-info [callData]="callData"></active-call-info>
    </div>

    <div class="mx-1 color-primary context-message" *ngIf="(queueName || call.getContext()) && !isCampaign">
      <!-- <div *ngIf="queueName" class="queue-name">{{ queueName }}</div> -->
      <div *ngIf="call.getContext()" class="did-name">{{ call.getContext() }}</div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="mx-1 color-primary welcome-message"
      *ngIf="call.getWelcomeMessage() && !isCampaign">
      <mat-icon class="pr-1">sms</mat-icon>
      <span>{{ call.getWelcomeMessage() }}</span>
    </div>
  </div>

  <div class="client-info-container call-transfer mb-1" [ngClass]="{
      'bg-gray': call.transferInType === CallTransferType.ASSISTED,
      'bg-primary': call.transferInType === CallTransferType.NOT_ASSISTED
    }" *ngIf="hasTransferIn() || hasTransferOut()">
    <ng-container *ngIf="hasTransferOut(); else tplTransferInInfo">
      <div class="transfer-avatar" *ngIf="transferOutUser">
        <user-avatar [user]="transferOutUser" width="70px" height="70px" class="avatar"></user-avatar>
      </div>
      <div class="transfer-info">
        <div class="transfer-into-title">
          <mat-icon>sync_alt</mat-icon>
          <span class="pl-1" *ngIf="call.isTransfering() && transferOutDestination">{{ 'call_active.transfering_to' |
            translate }} {{ transferOutDestination }}</span>
        </div>
        <div class="transfer-reason" *ngIf="call.isTransfering() && transferOutReason">{{ 'call_active.transfer_reason'
          | translate }}: {{ transferOutReason }}</div>
      </div>
    </ng-container>
    <ng-template #tplTransferInInfo>
      <div class="transfer-avatar" *ngIf="call.transferInUser">
        <user-avatar [user]="call.transferInUser" width="70px" height="70px" class="avatar"></user-avatar>
      </div>
      <div class="transfer-info">
        <div class="transfer-into-title">
          <mat-icon>sync_alt</mat-icon>
          <span class="pl-1" *ngIf="!call.isTransfering() && call.transferInUser">{{ 'call_active.transfering_from' |
            translate }} {{ call.transferInUser?.name }}</span>
        </div>
        <div class="transfer-reason" *ngIf="!call.isTransfering() && call.transferReason">{{
          'call_active.transfer_reason' | translate }}: {{ call.transferReason }}</div>
      </div>
    </ng-template>
  </div>

  <div class="call-actions" [ngClass]="{'keypad-visible' :keypadVisible}">
    <ng-container *ngIf="call.hasCallData() && call?.isAnswered()">
      <div class="small-buttons">
        <ng-container *ngIf="!call.isTransfering()">
          <div *ngIf="enterpriseParams.conferencing && queueName && !thirdCallData">
            <button mat-icon-button class="btn-add-participant-action" (click)="addParticipant()"
              [matTooltip]="'call_active.add_participant_hint'|translate">
              <mat-icon>person_add</mat-icon>
            </button>
          </div>
          <div>
            <button mat-icon-button class="btn-call-action" (click)="transferCall()"
              [matTooltip]="'call_active.transfer_hint'|translate">
              <mat-icon>swap_horiz</mat-icon>
            </button>
          </div>
          <div>
            <button mat-icon-button [ngClass]="{'onhold': call.isOnhold()}" class="btn-pause" (click)="toggleHold()"
              [matTooltip]="'call_active.pause_hint'|translate">
              <mat-icon class="icon-pause">{{ call.isOnhold() ? 'play_arrow' : 'pause' }}</mat-icon>
            </button>
          </div>
          <div *ngIf="call.canMute()">
            <button mat-icon-button class="btn-call-action btn-mic" [ngClass]="{'mic-off': call.isMuted()}"
              (click)="toggleMute()" matTooltip="{{'call_active.micro_hint'|translate}}">
              <mat-icon class="icon-mute">{{ call.isMuted() ? 'mic_off' : 'mic_on' }}</mat-icon>
            </button>
          </div>
          <div>
            <button mat-icon-button class="btn-call-action btn-dialpad" (click)="keypadVisible = !keypadVisible"
              [matTooltip]="'call_active.keypad_hint'|translate" [ngClass]="{'keypad-visible': keypadVisible}">
              <mat-icon>dialpad</mat-icon>
            </button>
          </div>
          <div>
            <button mat-icon-button class="btn-record" [ngClass]="{'recording': call.isRecording()}"
              [disabled]="!canRecord()" (click)="toggleRecording()"
              [matTooltip]="(call.isRecording() ? 'call_active.recording_active_hint' : 'call_active.recording_inactive_hint') | translate">
              <mat-icon class="icon-recording">radio_button_checked</mat-icon>
            </button>
          </div>
          <div *ngIf="canQualify()">
            <button mat-icon-button class="btn-call-action btn-edit" (click)="doQualify()"
              [matTooltip]="(call.pathQualIds.length || call.qualificationComment ? 'call.actions.change_qualification': 'call.actions.add_qualification')|translate">
              <mat-icon class="icon-edit">
                {{ call.pathQualIds.length || call.qualificationComment ? 'edit_note' : 'note_add' }}
              </mat-icon>
            </button>
          </div>
          <!-- <div>
            <button mat-icon-button (click)="changeVolumn()"
              matTooltip="{{'call_active.hint.change_volumn'|translate}}">
              <mat-icon>volume_up</mat-icon>
            </button>
          </div> -->

          <ng-container *ngIf="isCampaign">
            <div>
              <button mat-icon-button class="btn-call-action" color="primary" (click)="reschedule()"
                [matTooltip]="'call_active.hint.reschedule'|translate">
                <mat-icon>schedule</mat-icon>
              </button>
            </div>
            <!-- <div *ngIf="callData.details && callData.details.finished !== 1">
              <button mat-icon-button class="btn-call-action" color="warn" (click)="terminateSchedule()"
                matTooltip="{{'call_active.hint.terminate_schedule'|translate}}">
                <mat-icon>update_disabled</mat-icon>
              </button>
            </div> -->
          </ng-container>
        </ng-container>

        <ng-container *ngIf="call.isTransfering()">
          <button *ngIf="call.canConfirmTransfer()" mat-stroked-button color="primary" class="btn-call-action"
            (click)="confirmTransfer()">
            <mat-icon>play_arrow</mat-icon>
            {{ 'call_active.confirm_transfer'|translate }}
          </button>
          <button mat-stroked-button class="btn-call-action" color="warn" (click)="cancelTransfer()">
            <mat-icon>pause</mat-icon>
            {{ 'call_active.cancel_transfer'|translate }}
          </button>
        </ng-container>
      </div>
      <div *ngIf="keypadVisible" align="center" class="container-keypad">
        <keypad [activeCall]="call"></keypad>
      </div>
      <!-- <ng-template #keypadContainer>
        <button mat-button (click)="keypadVisible=false">
          <mat-icon>arrow_back</mat-icon> {{ 'call_active.hide_keypad' | translate }}
        </button>
      </ng-template> -->
    </ng-container>

    <div fxLayout="row" fxLayoutGap="50px" fxLayoutAlign="center center" *ngIf="call.canActiveCRM">
      <app-crm-incall-actions [activeCall]="call"></app-crm-incall-actions>
    </div>

    <div *ngIf="hasAnsweredElsewhere()" class="mt-10" fxLayoutAlign="center center">
      <span color="success" style="font-weight: bold"> Appel en cours sur un autre appareil</span>
    </div>
    <div *ngIf="unableToAnswer()" class="mt-10" fxLayout="column" fxLayoutAlign="center center">
      <span class="text-center" style="color:red">
        Impossible de répondre à cet appel.
        <br>
        Veuillez vérifier votre configuration réseau
      </span>
    </div>
    <div class="action-buttons" [ngClass]="{'action-buttons-footer': call.canActiveCRM}" fxFill fxLayout="row"
      fxLayoutGap="50px" fxLayoutAlign="center center">
      <!-- <button type="button" class="action-button bt-call" [hidden]="!call || !call.canAnswerHere()" [disabled]="!call || !call.canAnswerHere()" -->
      <button *ngIf="call?.canAnswerHere() || (inIFrame && call?.canBeAnsweredSomewhere())" mat-icon-button
        type="button" class="action-button bt-call" (click)="answerCall()">
        <mat-icon>call</mat-icon>
      </button>
      <button mat-icon-button type="button" class="action-button bt-hangup" (click)="endCall()">
        <mat-icon class="valign">call_end</mat-icon>
      </button>
      <!-- <button *ngIf="didSendSMS" mat-icon-button type="button"
        class="action-button bt-sendsms" (click)="sendSMS()">
        <mat-icon class="valign">sms</mat-icon>
      </button> -->
    </div>
  </div>

  <div class="bottom-right-container" *ngIf="isSMSFeaturedEnabled">
    <button mat-mini-fab type="button" [ngClass]="'action-button bt-sendsms'" (click)="sendSMS()">
      <mat-icon>textsms</mat-icon>
    </button>
  </div>

  <div class="vocal-command-container" *ngIf="vocalCommandUrl">
    <button *ngIf="!isRecordingVocalCommand()" mat-fab matTooltip="Vocal command" matTooltipPosition="left"
      (click)="startRecordingVocalCommand()">
      <mat-icon id="robo-btn" svgIcon="robo-head2"></mat-icon>
    </button>

    <span *ngIf="isRecordingVocalCommand()">{{ 'call_active.recording_active_hint'|translate }}</span>
    <button *ngIf="isRecordingVocalCommand()" mat-fab matTooltip="Send vocal command" matTooltipPosition="left"
      (click)="stopRecordingVocalCommand()">
      <mat-icon>send</mat-icon>
    </button>
  </div>

  <!-- <button mat-icon-button class="btn-volumn" (click)="changeVolumn()">
    <mat-icon>volume_up</mat-icon>
  </button>
  <button [disabled]="!call.canMute()" mat-icon-button class="btn-call-action btn-mic" (click)="toggleMute()"
    title="{{ 'call_active.micro_hint' | translate }}" [ngClass]="{'mic-off': call.isMuted()}">
    <mat-icon>{{ call.isMuted() ? 'mic_off' : 'mic_on' }}</mat-icon>
  </button> -->
</div>
